<template>
  <b-container class="my-5">
    <b-row v-if="order">
      <b-col><h3 class="text-secondary">Detalles de la orden {{ order.orderNumber }}</h3></b-col>
    </b-row>
    <b-row v-if="order">
      <b-col cols="12">
        <b-card-group deck>
          <b-card header="Dirección de envio" no-body>
            <b-card-body>
              <h6>{{ delivery.firstname }} {{ delivery.lastname }}</h6>
              <div>Dirección: {{ delivery.street }}, {{ delivery.externalNumber }}, {{ delivery.internalNumber }},
            {{ delivery.city }}, {{ delivery.zipcode }}</div>
            <div>Email: {{ delivery.email }}</div>
            <div>Tel.: {{ delivery.phone }}</div>
            </b-card-body>
          </b-card>
          <b-card header="Método de pago" no-body>
            <b-card-body>
              <div>Card Holder: {{ payment.metadata.card.cardholder.name }}</div>
              <div>Card Name: {{ payment.metadata.payment_method_id.toUpperCase() }}</div>
              <div>Card Number: ***** {{ payment.metadata.card.last_four_digits }}</div>
              <div>Exp Date: {{ payment.metadata.card.expiration_month }}/{{ payment.metadata.card.expiration_year }}</div>
            </b-card-body>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
    <b-row v-if="order">
      <b-col cols="12 mt-5">
        <div class="table-responsive mb-0">
          <b-table
            class="mb-0"
            :fields="productsTable.headers"
            :items="order.products">
          </b-table>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="order">
      <b-col cols="4 ml-auto">
        <table class="table">
          <tr>
            <th>Subtotal</th>
            <td class="text-right">{{ order.subtotal }}</td>
          </tr>
          <tr>
            <th>Shipping</th>
            <td class="text-right">{{ order.shipment.amount }}</td>
          </tr>
          <tr>
            <th>Cupón</th>
            <td class="text-right">0</td>
          </tr>
          <tr>
            <th>Descuento</th>
            <td class="text-right">0</td>
          </tr>
          <tr>
            <th>Total</th>
            <td class="text-right">{{ order.total }} {{ order.currency }}</td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <b-row v-if="order">
      <b-col cols="12">
        <b-card no-body>
          <b-card-body>
            <div class="row d-flex justify-content-between px-3 top">
              <div class="d-flex">
                <h5>ORDEN <span class="text-secondary font-weight-bold">{{ order.orderNumber }}</span></h5>
              </div>
              <div class="d-flex flex-column text-sm-right">
                <p class="mb-0">Entrega estimada <span class="font-weight-bold">01/12/19</span></p>
                <p>USPS <span class="font-weight-bold">234094567242423422898</span></p>
              </div>
            </div>
            <b-progress show-value>
              <b-progress-bar v-for="item in order.statusChanges" :label="$t('orders.status.' + item.status)" value="20" variant="purple" v-bind:key="item._id" />
            </b-progress>
            <div class="row justify-content-between top ml-1 mt-3 mr-1">
              <div class="d-flex">
                <font-awesome-icon size="3x" :icon="['fas', 'receipt']"/>
                <div class="d-flex flex-column ml-1">
                  <p class="font-weight-bold">Orden<br>Recibida</p>
                </div>
              </div>
              <div class="d-flex">
                <font-awesome-icon size="3x" :icon="['fas', 'receipt']"/>
                <div class="d-flex flex-column ml-1">
                  <p class="font-weight-bold">Orden<br>Preparada</p>
                </div>
              </div>
              <div class="d-flex">
                <font-awesome-icon size="3x" :icon="['fas', 'truck']"/>
                <div class="d-flex flex-column ml-1">
                  <p class="font-weight-bold">Pedido<br>Enviado</p>
                </div>
              </div>
              <div class="d-flex">
                <font-awesome-icon size="3x" :icon="['fas', 'home']"/>
                <div class="d-flex flex-column ml-1">
                  <p class="font-weight-bold">Envio<br>Recibido</p>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
export default {
  name: 'Order',
  computed: {
    delivery () {
      return this.order
        ? this.order.delivery
        : {}
    },
    payment () {
      return this.order
        ? this.order.payments.find(payment => payment.paymentMethod === 'credit_card')
        : {}
    }
  },
  async mounted () {
    try {
      const id = this.$route.params.id
      const { orderNumber } = this.$route.query
      const response = await this.$http.get(`/orders/${id}?orderNumber=${orderNumber}`)
      this.order = response.data
    } catch (error) {
      console.log(error)
      this.$bvToast.toast('No se pudo procesar el pago, por favor recargue la página y verifique sus datos bancarios', {
        title: 'Error procesando su pago',
        solid: true
      })
    }
  },
  data () {
    return {
      order: null,
      productsTable: {
        headers: [
          { key: 'quantity', label: 'Cantidad' },
          { key: 'name', label: 'Nombre' },
          { key: 'price', label: 'Precio' },
          { key: 'amount', label: 'Total' }
        ]
      }
    }
  }
}
</script>
